module.exports = __webpack_public_path__ + "img/d88fb6d.svg";